import React from "react";
import { useTranslation } from "react-i18next";
import { Calendar } from "@/components/ui/calendar";
import { CATS, LEGEND_ORDER } from "./constants";

export function CalendarSidebar({ anchor, setAnchor, availDays }) {
  const { t } = useTranslation();
  return (
    <div className="hidden lg:flex flex-col gap-5 p-4 border-r border-slate-200 bg-slate-50/40">
      <Calendar
        mode="single"
        selected={anchor}
        onSelect={(d) => d && setAnchor(d)}
        modifiers={{ hasSlots: (d) => availDays.has(d.toDateString()) }}
        modifiersClassNames={{ hasSlots: "cb-has-slots" }}
        className="w-full"
      />
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2.5">{t("cal.legend")}</p>
        <div className="space-y-1.5">
          {LEGEND_ORDER.map((k) => (
            <div key={k} className="flex items-center gap-2 text-xs text-slate-600">
              <span className={`w-3 h-3 rounded-sm shrink-0 ${CATS[k].dot}`} />
              {t(CATS[k].labelKey)}
            </div>
          ))}
        </div>
      </div>
      <p className="text-[11px] text-slate-400 leading-relaxed mt-auto">{t("cal.dragHint")}</p>
    </div>
  );
}
